// Phase 2I: Communication Templates + Automation Controls
import { api } from "./api";

export const COMMUNICATION_TYPE_META = {
  booking_confirmation: { label: "Booking confirmation", automatable: false },
  reconfirmation: { label: "Updated booking / reconfirmation", automatable: false },
  confirmation_reminder: { label: "Confirmation reminder", automatable: true },
  pickup_reminder: { label: "Pickup reminder", automatable: true },
  late_return: { label: "Late return", automatable: true },
  deposit_reminder: { label: "Deposit reminder", automatable: true },
  deposit_refund_update: { label: "Deposit refund / update", automatable: false },
  vehicle_replacement: { label: "Vehicle replacement", automatable: false },
  booking_change_response: { label: "Booking change response", automatable: false },
  cancellation: { label: "Cancellation", automatable: false },
  review_invitation: { label: "Review invitation", automatable: true },
};

export const CHANNEL_META = {
  email: { label: "Email" },
  sms: { label: "SMS" },
  whatsapp: { label: "Copy for WhatsApp" },
  messenger: { label: "Copy for Messenger" },
};

export const OUTCOME_META = {
  manual_send: { label: "Sent", bg: "bg-emerald-100", text: "text-emerald-800" },
  automated_send: { label: "Sent automatically", bg: "bg-emerald-100", text: "text-emerald-800" },
  copy_share: { label: "Copied", bg: "bg-slate-100", text: "text-slate-700" },
  provider_failed: { label: "Failed", bg: "bg-rose-100", text: "text-rose-800" },
  suppressed_duplicate: { label: "Suppressed (already sent)", bg: "bg-amber-100", text: "text-amber-800" },
};

export async function previewCommunication(bookingId, communicationType, { channel, language } = {}) {
  const { data } = await api.post("/communications/preview", {
    booking_id: bookingId, communication_type: communicationType, channel, language,
  });
  return data;
}

export async function sendCommunication(bookingId, communicationType, channel, { language, subject, body } = {}) {
  const { data } = await api.post("/communications/send", {
    booking_id: bookingId, communication_type: communicationType, channel, language, subject, body,
  });
  return data;
}

export async function listBookingCommunications(bookingId) {
  const { data } = await api.get(`/communications/bookings/${bookingId}/communications`);
  return data.items || [];
}

export async function listTemplates() {
  const { data } = await api.get("/communications/templates");
  return data.templates || [];
}

export async function saveTemplate(type, lang, subject, body) {
  const { data } = await api.put(`/communications/templates/${type}/${lang}`, { subject, body });
  return data;
}

export async function restoreDefaultTemplate(type, lang) {
  const { data } = await api.delete(`/communications/templates/${type}/${lang}`);
  return data;
}

export async function previewTemplate(type, lang) {
  const { data } = await api.get(`/communications/templates/${type}/preview`, { params: { language: lang } });
  return data;
}

export async function automationStatus() {
  const { data } = await api.get("/communications/automation/status");
  return data;
}

export async function listAutomationRules() {
  const { data } = await api.get("/communications/automation/rules");
  return data.rules || [];
}

export async function saveAutomationRule(type, rule) {
  const { data } = await api.put(`/communications/automation/rules/${type}`, rule);
  return data;
}
